import { AxiosResponse } from 'axios';
import axiosInstance from '../../services/axios/axios';
import { then, catchAxiosError } from '../../services/axios/_utility';

/**
 * Asynchronously retrieves end-user's metadata for Session variable consumption.
 * @param {Number} id end-user unique identifier.
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object>>} dictionary of key-value pairs of session variables
 */
export const getLegacyMetadata = async (esoId, dispatch = null) => {
	try {
		return axiosInstance
			.get('api/Identity/LegacyMetadata', {
				params: {
					esoId: esoId,
				},
			})
			.then(response => then(response, payload => payload, dispatch));
	} catch (e) {
		throw catchAxiosError(e);
	}
};
